// extracted by mini-css-extract-plugin
export default {"dialog":"PaymentDeclinedDialog_dialog__jZS83","icon":"PaymentDeclinedDialog_icon__O85Sk","formButton":"PaymentDeclinedDialog_formButton__WKAH3"};